
import InputNumber from 'primevue/inputnumber'
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import {
  getCurrentInstance,
  onMounted,
  ref,
  toRefs
} from 'vue'
import apiUseCase from '@/usecase/apiUseCase'
import { useStore } from 'vuex'
import { isNull } from 'lodash'

export default {
  components: {
    Dialog,
    // Form,
    // Field,
    // FieldArray,
    InputNumber,
    Button
  },
  props: {
    trxId: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    },
    ritId: {
      type: String,
      default: ''
    },
    revenues: {
      default: [] as any
    }
  },
  emits: ['hideDialog', 'reloadData'],
  setup(props: any, { emit }: any) {
    const app = getCurrentInstance()
    const {
      $toast
    } = app!.appContext.config.globalProperties
    const store = useStore()
    const isLoading = ref(false)
    const { show, trxId, ritId, revenues } = toRefs(props)
    const showModal = show.value
    const dataSource = ref([]) as any
    const dataSourceTemp = ref([]) as any
    const dataLatestRevision = ref() as any
    const TrxId = trxId.value
    const dataForm = ref([]) as any

    const endpoint = '/transaction/v1/Rit'

    const closeDialog = () => {
      emit('reloadData')
      emit('hideDialog')
    }

    const onSubmitConfirmation = async (val: any = '') => {
      // const deletedId = val === '' ? dataRow.value.Id : val
      const {
        error,
        message
      } = await apiUseCase.put(`${endpoint}/${ritId.value}/RitOtherRevenues`, dataForm.value)
      if (error) {
        $toast.add({
          severity: 'error',
          // summary: '',
          detail: message,
          group: 'bc',
          closable: false,
          life: 3000
        })
      } else {
        $toast.add({
          severity: 'success',
          // summary: 'Berhasil melakukan Approve Setoran',
          detail: 'Data Pendapatan Lain-Lain berhasil diubah',
          group: 'bc',
          closable: false,
          life: 3000
        })
        store.dispatch('setReloadDataList')
        emit('reloadData')
        closeDialog()
      }
      store.dispatch('hideLoading')
    }

    const onSubmit = () => {
      // console.log('dataSource', dataSource.value)
      store.dispatch('showLoading')
      dataForm.value = dataSource.value.map((data: any) => ({
        Id: data?.Id,
        RitId: data?.RitId,
        MsRevenueId: data?.MsRevenueId,
        RevenueName: data?.RevenueName,
        Quantity: data?.Quantity,
        Value: data?.Value
      }))

      console.log('dataForm', dataForm.value)
      onSubmitConfirmation()
    }

    onMounted(() => {
      // getDetail()
      dataSource.value = props.revenues
    })

    return {
      isLoading,
      showModal,
      closeDialog,
      dataSource,
      onSubmit,
      TrxId
    }
  }
}
